import { Alert, AlertColor, Snackbar } from "@mui/material"
import { ReactNode } from "react"
import { create } from "zustand"

export const NexusSnackbar = () => {
    const alert = useSnackbarStore((state) => state.alert)
    const closeSnackbar = useSnackbarStore((state) => state.handleClose)

    const handleClose = (_?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === "clickaway") {
            return
        }

        closeSnackbar()
    }

    return (
        <Snackbar open={!!alert} autoHideDuration={6000} onClose={handleClose}>
            <Alert severity={alert?.severity} onClose={handleClose} action={alert?.action}>
                {alert?.message}
            </Alert>
        </Snackbar>
    )
}

export interface SnackbarAlert {
    message: string
    severity: AlertColor
    action?: ReactNode
}

interface SnackbarStoreProps {
    alert?: SnackbarAlert
    handleClose: () => void
    handleOpen: (alert: SnackbarAlert) => void
}

export const useSnackbarStore = create<SnackbarStoreProps>((set) => ({
    handleOpen: (alert) => set({ alert }),
    handleClose: () => set({ alert: undefined }),
}))
